export default __webpack_public_path__ + "static/media/logo.8593ae4d.png";